import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import { withStyles } from '@material-ui/core/styles'
import { Translation } from 'react-i18next'
import {
  IconButton,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  DialogContentText,
  Snackbar
} from '@material-ui/core'
import ReactPaginate from 'react-paginate'
import moment from 'moment'
import SignatureCanvas from 'react-signature-canvas'
import { MySnackbarContentWrapper } from '../../utils/snackbar.utils'
import { scrollToTop } from '../../utils/scrollTo'
import LinearProgress from '@material-ui/core/LinearProgress'
import NavButton from './navButton.component'
import { industryRender } from '../../utils/showIndustry.utils'
import mobileView from '../../utils/mobile.utils'
import {
  defaultValues as invoiceFormValues,
  invoiceRowDefaultValues
} from '../invoice/invoiceForm.component'
import { convertIntToState, invoiceValues } from '../../utils/invoice.utils'
import ExpandablePanel from '../../utils/expandablePanel'
import AssignmentDetails from './assignmentDetails.component'
import PreviewOpenForWorkProfile from './previewOpenForWorkProfile.component'
import PushPinIcon from '@mui/icons-material/PushPin'
import { Tooltip } from '@material-ui/core'

import {
  ApplicationFilters,
  convertPortfolioNameLinksToObject,
  convertToObjects,
  generateProfileRatingsToObject,
  rearrangeByPinned,
  searchApplications,
  summaryRatings
} from '../../utils/openForWork.utils'
import { CloseIcon } from './closeIcon.component'
import { Link } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import { showInvoiceFormDialog } from '../../actions'

class ApplicationsComponent extends React.Component {
  componentDidMount() {
    this.props.getAreaOfWork()
    this.props.trackApplication()
    this.props.getAssignmentOfferToEmail()
    this.props.getAllAssignments()
    this.props.loadProfileStart()

    scrollToTop()
  }

  render() {
    return <Applications {...this.props} />
  }
}

const styles = (theme) => ({
  root: {
    width: '100%',
    overflowX: 'auto',
    backgroundColor: '#E0EFF3',

    '&::-webkit-scrollbar': {
      width: '12px !important',
      webkitOverflowScrolling: 'auto !important'
    },

    '&::-webkit-scrollbar-track': {
      webkitBoxShadow: 'inset 0 0 6px rgba(0,0,0,0.3) !important',
      webkitBorderRadius: '10px !important',
      borderRadius: '10px !important'
    },

    '&::-webkit-scrollbar-thumb': {
      webkitBorderRadius: '10px !important',
      borderRadius: '10px !important',
      background: '#41617D !important',
      webkitBoxShadow: 'inset 0 0 6px rgba(0,0,0,0.5) !important'
    },

    '&::-webkit-scrollbar-thumb:window-inactive': {
      background: '#41617D !important'
    }
  },
  tableHead: {
    fontSize: '13px',
    fontWeight: 'bold',
    borderBottom: '1px solid gray'
  },
  tableCell: {
    fontSize: '13px'
  },
  tableCell1: {
    border: 'none',
    fontSize: '13px',
    verticalAlign: 'top',
    maxWidth: '1000px',
    wordWrap: 'break-word'
  },
  expandP: {
    fontWeight: 1000
  },
  tableCell2: {
    fontSize: '13px',
    padding: '5px',
    height: '30px',
    verticalAlign: 'top'
  },
  tablecell2: {
    fontWeight: 'bold',
    fontSize: '13px',
    color: 'black',
    border: 'none',
    padding: 0,
    height: '30px'
  },
  labelP: {
    fontWeight: 1000,
    paddingTop: '20px'
  },
  previewLabel: {
    fontSize: '14px',
    fontWeight: 500,
    color: '#808080'
  },
  previewValue: {
    fontWeight: 500
  },
  searchField: {
    display: 'flex',
    justifyContent: 'space-between'
  },
  textField: {
    marginTop: theme.spacing(4),
    border: '1px solid gray',
    fontSize: '14px'
  },
  resize: {
    fontSize: '14px'
  },
  checkbox: {
    fontSize: '14px',
    color: '#808080',
    fontWeight: 500
  },
  button: {
    margin: 15
  },
  box: {
    border: '1px solid lightgrey',
    borderRadius: '5px'
  },
  table: {
    fontSize: '13px',
    borderTop: '2px solid #999'
  },
  searchField: {
    display: 'flex',
    flexFlow: mobileView ? 'column' : 'row',
    justifyContent: 'space-between',
    background: '#FFFFFF'
  },
  filterFields: {
    display: 'flex',
    flexWrap: 'wrap',
    padding: '0px 8px 30px',
    alignItems: 'flex-end',
    [theme.breakpoints.down('xs')]: {
      display: 'flex',
      flexDirection: 'column',
      padding: '0px 8px 30px',
      alignItems: 'stretch'
    }
  },
  applicationsContainer: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-between',
    gap: '15px',
    marginTop: '15px'
  },
  applicationCard: {
    display: 'flex',
    flexDirection: 'column',
    background: '#FFFFFF 0% 0% no-repeat padding-box',
    borderRadius: '3px',
    padding: '15px',
    flex: '1 1 calc(50% - 10px)' /* Ensures two cards per row */,
    minWidth: '300px',
    maxWidth: '49%',
    '&:hover': {
      cursor: 'pointer',
      padding: '14px',
      border: '1px solid #44c0cc'
    }
  },
  newApplication: {
    border: '2px solid #F67131'
  },
  applicationCardInfo: {
    display: 'flex',
    gap: '15px',
    flex: '1 1 calc(50% - 20px)' /* Ensures two cards per row */,
    position: 'relative'
  },
  pin: {
    position: 'absolute',
    top: '-10px',
    right: '-10px',
    fontSize: '20px',
    background: 'none',
    border: 'none',
    cursor: 'pointer'
  },
  companyName: {
    width: '125px',
    height: '125px',
    borderRadius: '50%',
    backgroundColor: '#80808040',
    alignContent: 'center',
    '& > p': {
      marginLeft: '10px',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis'
    }
  },
  applicationContent: {
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    justifyContent: 'space-between'
  },
  h3: {
    margin: 0,
    fontWeight: 'bold',
    fontSize: '13px',
    color: '#000000'
  },
  title: {
    marginTop: '4px',
    fontSize: '13px',
    color: '#000000'
  },
  description: {
    color: '#7D7D7D',
    fontSize: '12px'
  },
  cardBottom: {
    display: 'flex',
    flexWrap: 'wrap'
  },
  box: {
    border: '1px solid lightgrey',
    borderRadius: '5px'
  },
  previewField: {
    minHeight: '70px'
  }
})

const defaultValues = {
  job_title: '',
  industry: [],
  company_name: '',
  city_name: '',
  pageSize: 10,
  pinned: false,
  status: ''
}

const statusOptions = [
  { value: '', label: '' },
  { value: 'Offer accepted by entrepreneur', label: 'application_stt.4' },
  { value: 'Offer rejected by entrepreneur', label: 'application_stt.5' },
  // { value: 'pending', label: 'application_stt.6' }, // This is now return as Offer sent by employer
  { value: 'Offer sent by employer', label: 'application_stt.6' },
  { value: 'Offer signed', label: 'application_stt.7' },
  { value: 'Application sent', label: 'application_stt.0' }
]

const Applications = ({
  classes,
  myAssignmentRows,
  openSignBox,
  signPad,
  cancelOpenSignBox,
  askBeforeRejectAssignment,
  cancelRejectAssignment,
  openBeforeRejectDialog,
  rejectAssignment,
  getApplicationProfile,
  applicationProfileData,
  signAndSendAssignment,
  showSnackbar,
  showFailedSnackbar,
  closeApplicationSnackbar,
  showSignSendLoader,
  areaOfWorkDict,
  saveDraftInvoiceSuccess,
  saveDraftInvoiceFailed,
  updateViewApplication,
  pinApplication,
  pinAssignment,
  saveInvoiceDraft,
  editInvoice,
  applicationPageSize = 10,
  getAssignmentOfferToEmail
}) => {
  const [isSearchApplication, setIsSearchApplication] = React.useState(false)
  const [searchApplicationValues, setSearchApplicationValues] =
    React.useState(defaultValues)

  const [page, setPage] = React.useState(0)
  const [selectedAssignment, setSelectedAssignment] = React.useState(null)

  const filteredApplicationRows = searchApplications(
    myAssignmentRows,
    searchApplicationValues
  )

  const filteredPinnedApplications = rearrangeByPinned(
    rearrangeByPinned(filteredApplicationRows, 'pinned_assignment_user'),
    'pinned_application'
  )

  const [isPreview, setIsPreview] = React.useState(false)
  const [reason, setReason] = React.useState('')

  const [appliedProfileOpen, setAppliedProfileOpen] = React.useState(false)
  // console.log('huong selectedAssignment >>>>>>>>>>>>>>>>>.', selectedAssignment)
  const invoice_id = selectedAssignment?.invoice_id ?? null
  const draftInvoiceValues = invoiceValues(
    invoiceFormValues,
    invoiceRowDefaultValues,
    selectedAssignment
  )

  const handlePreview = () => {
    setIsPreview(true)
  }

  const handleReasonOnchange = (event) => {
    setReason(event.target.value)
  }

  const dispatch = useDispatch()
  const handleEditInvoice = (id) => {
    dispatch(showInvoiceFormDialog())
    dispatch(editInvoice(id))
  }

  const offeredStatus =
    selectedAssignment?.agreement_status_entrepreneur ===
      'Offer sent by employer' ||
    selectedAssignment?.agreement_status_entrepreneur === 'pending'
      ? 'Offer awaits approval'
      : selectedAssignment?.agreement_status_entrepreneur

  const isDisable = offeredStatus !== 'Offer awaits approval' ? true : false

  const covertOfferedStatus =
    offeredStatus === 'Offer accepted by entrepreneur'
      ? 4
      : offeredStatus === 'Offer rejected by entrepreneur'
      ? 5
      : offeredStatus === 'Offer awaits approval'
      ? 6
      : offeredStatus === 'Offer signed'
      ? 7
      : 0

  // Sign the document
  const signPadRef = React.useRef(null)
  const clear = () => {
    signPadRef.current.clear()
  }
  // Data URL - sign picture
  const [trimmedDataURL, setTrimmedDataURL] = React.useState(null)
  const trim = () => {
    if (signPadRef.current) {
      const trimmedCanvas = signPadRef.current.getTrimmedCanvas()
      if (trimmedCanvas.width !== 1 && trimmedCanvas.height !== 1) {
        setTrimmedDataURL(trimmedCanvas.toDataURL('image/png'))
      } else {
        setTrimmedDataURL(null)
      }
    }
  }

  React.useEffect(() => {
    if (trimmedDataURL) {
      signAndSendAssignment(
        selectedAssignment,
        trimmedDataURL,
        draftInvoiceValues
      )
    }
  }, [trimmedDataURL])

  const assignment_type =
    selectedAssignment?.assignment_type === 'Until further notice' ||
    selectedAssignment?.assignment_type === 'until_further_notice'
      ? 1
      : selectedAssignment?.assignment_type === 'Temporary' ||
        selectedAssignment?.assignment_type === 'temporary'
      ? 2
      : selectedAssignment?.assignment_type ===
          'Temporary with a notice period' ||
        selectedAssignment?.assignment_type === 'temporary_with_notice'
      ? 3
      : selectedAssignment?.assignment_type === 'So far until completion' ||
        selectedAssignment?.assignment_type === 'until_completion'
      ? 4
      : ''

  let salaryModel
  if (
    selectedAssignment?.salary_model === 'Hourly rate' ||
    selectedAssignment?.salary_model === 'hourly_rate'
  ) {
    salaryModel = 1
  } else if (
    selectedAssignment?.salary_model === 'Contract price' ||
    selectedAssignment?.salary_model === 'contract_price'
  ) {
    salaryModel = 2
  } else if (
    selectedAssignment?.salary_model === 'Unit price' ||
    selectedAssignment?.salary_model === 'unit_price'
  ) {
    salaryModel = 3
  } else if (
    selectedAssignment?.salary_model === 'Commission' ||
    selectedAssignment?.salary_model === 'commission'
  ) {
    salaryModel = 4
  }

  return (
    <Translation>
      {(t) => {
        return (
          <div className="container">
            <div className="row">
              <div className="dashboard-content-header">
                <h1></h1>
              </div>
            </div>
            <NavButton t={t} type="openforwork" />
            <div className="row">
              <div className="dashboard-content-header">
                <div className="col-xs-12 col-sm-12 col-lg-12">
                  <ExpandablePanel
                    title={t('application.h1')}
                    renderBody={() => (
                      <div className={classes.root}>
                        <ApplicationFilters
                          t={t}
                          filters={searchApplicationValues}
                          onChange={setSearchApplicationValues}
                          classes={classes}
                          statusOptions={statusOptions}
                          resetSelectedPage={() => setPage(0)}
                        />
                        {createApplicationTable(
                          t,
                          classes,
                          filteredPinnedApplications,
                          page,
                          searchApplicationValues?.pageSize ??
                            applicationPageSize,
                          setSelectedAssignment,
                          updateViewApplication,
                          pinAssignment,
                          pinApplication
                        )}
                        <div className="panel-body">
                          {filteredApplicationRows.length > 0 ? (
                            <ReactPaginate
                              previousLabel={
                                <i className="fa fa-chevron-left" />
                              }
                              nextLabel={<i className="fa fa-chevron-right" />}
                              breakLabel={'...'}
                              breakClassName={'break-me'}
                              pageCount={
                                !!filteredApplicationRows
                                  ? Math.ceil(
                                      filteredApplicationRows.length /
                                        searchApplicationValues.pageSize
                                    )
                                  : 0
                              }
                              marginPagesDisplayed={2}
                              pageRangeDisplayed={5}
                              onPageChange={(event) => {
                                setPage(event.selected)
                              }}
                              containerClassName={'pagination'}
                              subContainerClassName={'pages pagination'}
                              activeClassName={'active'}
                              forcePage={page}
                            />
                          ) : null}
                        </div>
                      </div>
                    )}
                    defaultExpanded={true}
                    isAddExtraPaddingEnd={true}
                    paddingEnd={90}
                    isSearchApplication={isSearchApplication}
                    setIsSearchApplication={setIsSearchApplication}
                    pageLocation="open_for_work_applications"
                  />
                </div>
              </div>
            </div>
            <Dialog
              open={selectedAssignment !== null}
              onClose={() => setSelectedAssignment(null)}
              fullWidth
              maxWidth="md"
            >
              <CloseIcon
                fontSize="large"
                onClick={() => setSelectedAssignment(null)}
              />
              <DialogTitle id="alert-dialog-title">
                <div
                  style={{
                    textAlign: 'center',
                    color: '#000000',
                    fontSize: '15px'
                  }}
                >
                  {t('application.dialogTitle')}
                </div>
              </DialogTitle>
              <DialogContent>
                <div>
                  <AssignmentDetails
                    t={t}
                    classes={classes}
                    assignmentType={t(`assignmentType.${assignment_type}`)}
                    salaryModel={t(`salaryModel.${salaryModel}`)}
                    areaOfWorkDict={areaOfWorkDict}
                    industryRender={industryRender}
                    offeredAssignmentStatus={t(
                      `application_stt.${covertOfferedStatus}`
                    )}
                    company_name={selectedAssignment?.company_name}
                    location={selectedAssignment?.location}
                    amount={selectedAssignment?.amount}
                    contract_salary={selectedAssignment?.contract_salary}
                    unit_price={selectedAssignment?.unit_price}
                    hourly_rate={selectedAssignment?.hourly_rate}
                    weekly_hours={selectedAssignment?.weekly_hours}
                    job_title={selectedAssignment?.job_title}
                    assignment_begins={selectedAssignment?.assignment_begins}
                    assignment_ends={selectedAssignment?.assignment_ends}
                    status={selectedAssignment?.status}
                    agreement_status_entrepreneur={
                      selectedAssignment?.agreement_status_entrepreneur
                    }
                    industry_type={selectedAssignment?.industry_type}
                    last_date_of_application={
                      selectedAssignment?.last_date_of_application
                    }
                    type_of_employment={selectedAssignment?.type_of_employment}
                    notice_period={selectedAssignment?.notice_period}
                    assignment_contents={
                      selectedAssignment?.assignment_contents
                    }
                    assignment_id={selectedAssignment?.assignment_id}
                    job_description={selectedAssignment?.job_description}
                    enterpreneur_email={null}
                  />
                </div>
              </DialogContent>
              <DialogActions style={{ padding: '8px 24px' }}>
                <div style={{ margin: '0 10px' }}>
                  {(selectedAssignment?.status === 3 ||
                    selectedAssignment?.applied_date !== undefined) && ( // assignment that is applied
                    <div
                      style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        paddingTop: '10px'
                      }}
                    >
                      <div>
                        <b>
                          {t('assignment.p')}
                          {moment(selectedAssignment?.applied_date).format(
                            'DD.MM.YYYY'
                          )}{' '}
                        </b>
                      </div>
                      <div>
                        <Button
                          variant="contained"
                          style={{ fontSize: '13px' }}
                          onClick={() => {
                            getApplicationProfile(selectedAssignment)
                            setAppliedProfileOpen(true)
                          }}
                        >
                          {t('assignment.btn8')}
                        </Button>
                      </div>
                    </div>
                  )}
                  {(selectedAssignment?.agreement_status_entrepreneur ===
                    'Offer sent by employer' ||
                    selectedAssignment?.agreement_status_entrepreneur ===
                      'pending') && (
                    <div
                      style={{ display: 'flex', justifyContent: 'flex-end' }}
                    >
                      <Button
                        variant="contained"
                        style={{ fontSize: '13px', marginRight: '15px' }}
                        onClick={handlePreview}
                        disabled={isDisable}
                      >
                        <a
                          href={selectedAssignment?.contract_path}
                          style={{ color: 'white' }}
                        >
                          {t('application.btn2')}
                        </a>
                      </Button>
                      <Tooltip
                        title={
                          !isPreview ? (
                            <p style={{ fontSize: '10px' }}>
                              {t('application.note1')}
                            </p>
                          ) : (
                            ''
                          )
                        }
                        placement="top"
                      >
                        <span>
                          <Button
                            variant="contained"
                            style={{ fontSize: '13px', marginRight: '15px' }}
                            disabled={!isPreview || isDisable}
                            onClick={() => {
                              openSignBox(selectedAssignment)
                            }}
                          >
                            {t('application.btn5')}
                          </Button>
                        </span>
                      </Tooltip>
                      <Button
                        variant="outlined"
                        style={{ fontSize: '13px', marginRight: '0px' }}
                        onClick={() => {
                          askBeforeRejectAssignment(selectedAssignment)
                        }}
                        disabled={isDisable}
                      >
                        {t('application.btn6b')}
                      </Button>
                    </div>
                  )}
                  {/*When the agreement is signed by both parties*/}
                  {selectedAssignment?.agreement_status_entrepreneur ===
                    'Offer signed' &&
                  (salaryModel === 2 ||
                    salaryModel === 3 ||
                    (salaryModel === 4 && assignment_type !== 4)) ? (
                    invoice_id === null ? (
                      <div className="pull-right">
                        <Button
                          variant="contained"
                          onClick={() => {
                            saveInvoiceDraft(draftInvoiceValues)
                          }}
                        >
                          {t('application.btn8')}
                        </Button>
                      </div>
                    ) : selectedAssignment?.status === 0 ? (
                      <div className="pull-right">
                        <Link to="/dashboard/invoice">
                          <Button
                            variant="contained"
                            onClick={() => {
                              handleEditInvoice(invoice_id)
                              setSelectedAssignment(null)
                            }}
                          >
                            {t('application.btn9')}
                          </Button>
                        </Link>
                      </div>
                    ) : (
                      <div className="pull-right">
                        <b>
                          {t('application.invoiceStatusInfo') +
                            convertIntToState(selectedAssignment?.status)}
                        </b>
                      </div>
                    )
                  ) : salaryModel === 4 &&
                    assignment_type === 4 &&
                    selectedAssignment?.agreement_status_entrepreneur ===
                      'Offer signed' ? (
                    <i>{t('application.note3')}</i>
                  ) : salaryModel === 1 &&
                    selectedAssignment?.agreement_status_entrepreneur ===
                      'Offer signed' ? (
                    <i>{t('application.note2')}</i>
                  ) : null}
                </div>
              </DialogActions>
            </Dialog>
            <Dialog
              open={appliedProfileOpen}
              onClose={() => setAppliedProfileOpen(false)}
              aria-labelledby="alert-dialog-title"
              aria-describedby="alert-dialog-description"
              fullWidth
              maxWidth="md"
            >
              <CloseIcon
                fontSize="large"
                onClick={() => setAppliedProfileOpen(false)}
              />
              <DialogTitle id="alert-dialog-title">
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    textAlign: 'center'
                  }}
                >
                  <span style={{ fontSize: '20px' }}>
                    {t('assignment.title')}
                  </span>
                  <div style={{ color: '#000000' }}>
                    <p>
                      {selectedAssignment?.company_name} |{' '}
                      {selectedAssignment?.job_title} |{' '}
                      {selectedAssignment?.location}
                    </p>
                  </div>
                </div>
              </DialogTitle>
              <DialogContent>
                <PreviewOpenForWorkProfile
                  t={t}
                  classes={classes}
                  formValues={applicationProfileData}
                  profile_pic={applicationProfileData?.profile_image_path}
                  userData={null}
                  info_consent_allowed={
                    applicationProfileData?.info_consent_allowed
                  }
                  applicant_name={applicationProfileData?.applicant_name}
                  applicant_email={applicationProfileData?.applicant_email}
                  applicant_phone_no={
                    applicationProfileData?.applicant_phone_no
                  }
                  applicant_address={applicationProfileData?.applicant_address}
                  applicant_zipcode={applicationProfileData?.applicant_zipcode}
                  applicant_city={applicationProfileData?.applicant_city}
                  ratingsByCompany={generateProfileRatingsToObject(
                    applicationProfileData?.profile_rating
                  )}
                  ratingsSummary={
                    applicationProfileData?.profile_rating !== null &&
                    applicationProfileData?.profile_rating !== undefined
                      ? summaryRatings(
                          generateProfileRatingsToObject(
                            applicationProfileData?.profile_rating
                          )
                        )
                      : null
                  }
                  portfolios={convertToObjects(
                    applicationProfileData?.merged_filepaths
                  )}
                  AreaOf_Expertise={applicationProfileData?.area_of_expertise
                    .split(',')
                    .map((num) => Number(num.trim()))}
                  role_title={applicationProfileData?.title}
                  short_des={applicationProfileData?.short_description}
                  inputCV={applicationProfileData?.cv_path}
                  CV_file={applicationProfileData?.cv_filename}
                  linkRow={convertPortfolioNameLinksToObject(
                    applicationProfileData?.portfolio_name_link
                  )}
                  work_experience={applicationProfileData?.work_experience}
                />
              </DialogContent>
              <DialogActions style={{ padding: '8px 24px' }}>
                <div className="pull-right" style={{ display: 'flex' }}>
                  <p
                    style={{
                      marginTop: 'auto',
                      paddingRight: 20,
                      fontWeight: 1000
                    }}
                  >
                    {t('assignment.p')}{' '}
                    {moment(selectedAssignment?.applied_date).format(
                      'DD.MM.YYYY'
                    )}
                  </p>
                </div>
              </DialogActions>
            </Dialog>
            {/* Sign contract */}
            <Dialog
              open={signPad}
              aria-labelledby="alert-dialog-title"
              aria-describedby="alert-dialog-description"
              fullWidth
              maxWidth="md"
            >
              <DialogTitle id="alert-dialog-title">
                <p style={{ textAlign: 'center', color: 'black' }}>
                  {t('application.title1')} {selectedAssignment?.company_name}
                </p>
              </DialogTitle>
              <DialogContent>
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center'
                  }}
                >
                  <SignatureCanvas
                    penColor="black"
                    canvasProps={{
                      width: 800,
                      height: 200,
                      className: 'sigCanvas',
                      style: { border: '1px solid black' }
                    }}
                    ref={signPadRef}
                  />
                </div>
              </DialogContent>
              <DialogActions>
                <div>
                  <Button variant="outlined" onClick={cancelOpenSignBox}>
                    {t('application.btn3')}
                  </Button>
                  <Button variant="outlined" onClick={clear}>
                    {t('application.btn4')}
                  </Button>
                  <Button
                    variant="contained"
                    onClick={() => {
                      trim()
                      // setSelectedAssignment(null)
                    }}
                  >
                    {t('application.btn5')}
                  </Button>
                </div>
              </DialogActions>
            </Dialog>
            <Dialog
              open={openBeforeRejectDialog}
              onClose={cancelRejectAssignment}
              aria-labelledby="alert-dialog-title"
              aria-describedby="alert-dialog-description"
            >
              <DialogTitle id="alert-dialog-title">
                <span style={{ fontSize: '20px' }}>
                  {t('application.title2')}
                </span>
              </DialogTitle>
              <DialogContent>
                <DialogContentText id="alert-dialog-description">
                  <span style={{ fontSize: '14px' }}>
                    {t('application.content2')}
                  </span>
                </DialogContentText>
                <div>
                  <p style={{ color: '#0000008A' }}>
                    {t('application.reason')}
                  </p>
                  <input
                    type="text"
                    name="message"
                    onChange={handleReasonOnchange}
                    style={{
                      width: '100%',
                      maxWidth: '300px',
                      boxSizing: 'border-box',
                      padding: '5px'
                    }}
                  />
                </div>
              </DialogContent>
              <DialogActions>
                <div className="pull-right">
                  <Button variant="outlined" onClick={cancelRejectAssignment}>
                    {t('application.btn3')}
                  </Button>
                  <Button
                    variant="contained"
                    onClick={() => {
                      rejectAssignment(reason, selectedAssignment)
                      setSelectedAssignment(null)
                    }}
                  >
                    {t('application.btn6b')}
                  </Button>
                </div>
              </DialogActions>
            </Dialog>
            <Dialog
              open={showSignSendLoader}
              aria-describedby="alert-dialog-description"
            >
              <DialogContent>
                <DialogContentText
                  id="alert-dialog-description"
                  style={{ fontSize: '15px', margin: '20px' }}
                >
                  {t('application.loader')}
                </DialogContentText>
              </DialogContent>
              <div className={classes.progress}>
                <LinearProgress />
              </div>
            </Dialog>
            <Snackbar
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'center'
              }}
              open={showSnackbar}
              autoHideDuration={6000}
              onClose={() => {
                closeApplicationSnackbar()
                setSelectedAssignment(null)
              }}
            >
              <MySnackbarContentWrapper
                onClose={() => {
                  closeApplicationSnackbar()
                  setSelectedAssignment(null)
                }}
                variant="success"
                message={
                  saveDraftInvoiceSuccess
                    ? t('application.msg3')
                    : t('application.msg1')
                }
              />
            </Snackbar>
            <Snackbar
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'center'
              }}
              open={saveDraftInvoiceSuccess}
              autoHideDuration={4000}
              onClose={() => {
                closeApplicationSnackbar()
                setSelectedAssignment(null)
                getAssignmentOfferToEmail()
              }}
            >
              <MySnackbarContentWrapper
                onClose={() => {
                  closeApplicationSnackbar()
                  setSelectedAssignment(null)
                  getAssignmentOfferToEmail()
                }}
                variant="success"
                message={t('application.msg3')}
              />
            </Snackbar>
            <Snackbar
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'center'
              }}
              open={saveDraftInvoiceFailed}
              autoHideDuration={6000}
              onClose={() => {
                closeApplicationSnackbar()
                setSelectedAssignment(null)
              }}
            >
              <MySnackbarContentWrapper
                onClose={() => {
                  closeApplicationSnackbar()
                  setSelectedAssignment(null)
                }}
                variant="error"
                message={t('application.msg4')}
              />
            </Snackbar>
            <Snackbar
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'center'
              }}
              open={showFailedSnackbar}
              autoHideDuration={4000}
              onClose={() => {
                closeApplicationSnackbar()
              }}
            >
              <MySnackbarContentWrapper
                variant="error"
                message={t('application.msg2')}
                onClose={() => {
                  closeApplicationSnackbar()
                }}
              />
            </Snackbar>
          </div>
        )
      }}
    </Translation>
  )
}

const createApplicationTable = (
  t,
  classes,
  filteredPinnedApplications,
  selected,
  applicationPageSize,
  setSelectedAssignment,
  updateViewApplication,
  pinAssignment,
  pinApplication
) => (
  <div className={classes.applicationsContainer}>
    {filteredPinnedApplications
      .slice(
        selected * applicationPageSize,
        selected * applicationPageSize + applicationPageSize
      )
      .map((row, index) => (
        <ApplicationCard
          t={t}
          data={row}
          key={index}
          classes={classes}
          setSelectedAssignment={setSelectedAssignment}
          updateViewApplication={updateViewApplication}
          pinAssignment={pinAssignment}
          pinApplication={pinApplication}
        />
      ))}
  </div>
)

const ApplicationCard = ({
  t,
  data,
  classes,
  setSelectedAssignment,
  updateViewApplication,
  pinAssignment,
  pinApplication
}) => {
  const offeredStatus =
    data.agreement_status_entrepreneur === 'Offer sent by employer' ||
    data.agreement_status_entrepreneur === 'pending'
      ? 'Offer awaits approval'
      : data.agreement_status_entrepreneur

  const covertOfferedStatus =
    offeredStatus === 'Offer accepted by entrepreneur'
      ? 4
      : offeredStatus === 'Offer rejected by entrepreneur'
      ? 5
      : offeredStatus === 'Offer awaits approval'
      ? 6
      : offeredStatus === 'Offer signed'
      ? 7
      : 0

  const assignmentContents =
    data?.assignment_contents?.length > 150
      ? data?.assignment_contents?.slice(0, 150) + '...'
      : data?.assignment_contents

  const job_description =
    data?.job_description?.length > 150
      ? data?.job_description?.slice(0, 150) + '...'
      : data?.job_description

  const newNotification =
    data.is_application_viewed === 0 &&
    data.agreement_status_entrepreneur === 'Offer sent by employer'

  return (
    <div
      className={classes.applicationCard}
      onClick={() => {
        setSelectedAssignment(data),
          newNotification && updateViewApplication(data.agreement_id)
      }}
    >
      <div className={classes.applicationCardInfo}>
        <IconButton
          size="small"
          className={classes.pin}
          style={
            data.pinned_assignment_user || data.pinned_application
              ? { color: '#F67131' }
              : {}
          }
          onClick={(e) => {
            e.stopPropagation()
            if (data.hasOwnProperty('agreement_id')) {
              pinApplication(data.agreement_id)
            } else {
              pinAssignment(data.assignment_id)
            }
          }}
        >
          <PushPinIcon fontSize="large" />
        </IconButton>
        <div
          className={classNames(
            classes.companyName,
            newNotification && classes.newApplication
          )}
        >
          <p>{data.company_name}</p>
        </div>

        <div className={classes.applicationContent}>
          <div>
            <h3 className={classes.h3}>
              {data.job_title !== 'N/A'
                ? data.job_title
                : t('application.title')}
              {newNotification && (
                <span style={{ color: '#F67131', fontSize: '20px' }}> •</span>
              )}
            </h3>
            <p className={classes.title}>{data.company_name}</p>
            <span
              className={classes.description}
              dangerouslySetInnerHTML={{
                __html: assignmentContents || job_description
              }}
            ></span>
          </div>
          <div className={classes.cardBottom}>
            <div style={{ marginRight: '10px' }}>
              {'Status:' + ' ' + t(`application_stt.${covertOfferedStatus}`)}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

ApplicationsComponent.propTypes = {
  classes: PropTypes.object.isRequired
}

export default withStyles(styles)(ApplicationsComponent)
